import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Subject, of, timer, Observable } from 'rxjs';
import { debounce, switchMap } from 'rxjs/operators';
import { FolderCardVariants } from '../types';
import type { CardProperties } from '../types';

@Component({
    selector: 'fcp-folder-card',
    templateUrl: './fcp-folder-card.component.html',
    styleUrls: ['./fcp-folder-card.component.less', '../fcp-card.component.less'],
    standalone: false
})
export class FcpFolderCardComponent implements OnInit {
    @Input() properties: CardProperties;

    @Output() outputActions: EventEmitter<any> = new EventEmitter<any>();
    @Output() outputClick: EventEmitter<any> = new EventEmitter<any>();

    public showActions: Observable<boolean>;
    private actionsMenuTriggered: Subject<boolean> = new Subject<boolean>();
    public showActionsIcon = false;
    public imageList: string[] = [];

    ngOnInit() {
        if (this.properties.actionsList?.length > 0) {
            this.showActionsIcon = true;
        }

        this.showActions = this.actionsMenuTriggered.pipe(
            debounce((state) => (state ? timer(0) : timer(200))),
            switchMap((state) => of(state))
        );

        this.imageList = this.properties.imageList;
        if (this.imageList.length > 0 && this.imageList.length < 4) {
            for (let i = 0; i < 4; i++) {
                this.imageList[i] = this.imageList[i] ? this.imageList[i] : null;
            }
        }
    }

    showActionsMenu(state: boolean): void {
        this.actionsMenuTriggered.next(state);
    }

    callAction(data): void {
        this.outputActions.next(data);
    }

    getCardVariant(variantName: keyof typeof FolderCardVariants): string {
        return FolderCardVariants[variantName];
    }

    onClick() {
        this.outputClick.emit(this.properties.payload);
    }
}
